import _styled from "@emotion/styled/base";

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

import Typography from '@segment/matcha/components/Typography';
export var Text = /*#__PURE__*/_styled(Typography, true ? {
  target: "e1abg28t0"
} : {
  target: "e1abg28t0",
  label: "Text"
})(true ? {
  name: "ti75j2",
  styles: "margin:0"
} : {
  name: "ti75j2",
  styles: "margin:0",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi93b3JrZGlyL2xpYnMvbWF0Y2hhL3JlY2lwZXMvQWNjb3JkaW9uL1RleHQvVGV4dC52aWV3cy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFNc0MiLCJmaWxlIjoiL3dvcmtkaXIvbGlicy9tYXRjaGEvcmVjaXBlcy9BY2NvcmRpb24vVGV4dC9UZXh0LnZpZXdzLnRzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnXG5cbmltcG9ydCBUeXBvZ3JhcGh5IGZyb20gJ0BzZWdtZW50L21hdGNoYS9jb21wb25lbnRzL1R5cG9ncmFwaHknXG5pbXBvcnQgdHlwZSB7IFR5cG9ncmFwaHlQcm9wcyB9IGZyb20gJ0BzZWdtZW50L21hdGNoYS9jb21wb25lbnRzL1R5cG9ncmFwaHkvVHlwb2dyYXBoeS52aWV3cydcblxuZXhwb3J0IHR5cGUgVGV4dFRva2VucyA9IFR5cG9ncmFwaHlQcm9wc1xuZXhwb3J0IGNvbnN0IFRleHQgPSBzdHlsZWQoVHlwb2dyYXBoeSlgXG4gIG1hcmdpbjogMDtcbmBcbiJdfQ== */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});